import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { REACH } = STEP_IDENTIFIER_NAME;

export const reach: StepConfig = {
	name: REACH,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
